export { LoyaltyPanel } from './loyalty-panel';
